// extracted by mini-css-extract-plugin
module.exports = {"select":"app-select-input_select_2PFZ5","option":"app-select-input_option_25h7J"};